// ========================================================================
// This file is auto-generated by the `yarn naptime:types` script
// ========================================================================

import NaptimeResource from 'bundles/naptimejs/resources/NaptimeResource';

// ========================================================================
// Definitions for resource data types
// ========================================================================

export interface GenericExternalUserData {
  fullName: string;
  email: string;
  externalId?: string | null;
}

export interface ExternalUserDataGenericExternalUserData {
  typeName: 'genericExternalUserData';
  definition: GenericExternalUserData;
}

export type ExternalUserData = ExternalUserDataGenericExternalUserData;

export type ExternalUserDataTypeName = 'genericExternalUserData';

export interface ProgramInvitee {
  name: string;
  email: string;
  externalUserData: ExternalUserData;
}

export interface ProgramInvitationsV1 {
  id: string;
  programId: string;
  invitee: ProgramInvitee;
  expiresAt: number;
  declines: boolean;
  sendAttemptTimes: Array<number>;
  reminderSendTimes: Array<number>;
  rosterId: string;
  thirdPartyOrganizationId: string;
  createdAt?: number | null;
}

// ========================================================================
// Definitions for naptime-link
// ========================================================================

export interface ProgramInvitationsV1Connection {
  elements: Array<ProgramInvitationsV1> | null;
}

// ========================================================================
// Definitions for naptime-link queries
// ========================================================================

export interface ProgramInvitationsV1ByEmailQuery {
  ProgramInvitationsV1: {
    byEmail: ProgramInvitationsV1Connection | null;
  } | null;
}

export interface ProgramInvitationsV1ByEmailQueryVariables {
  email: string;
  includes?: string | null;
}

export interface ProgramInvitationsV1ByProgramQuery {
  ProgramInvitationsV1: {
    byProgram: ProgramInvitationsV1Connection | null;
  } | null;
}

export interface ProgramInvitationsV1ByProgramQueryVariables {
  programId: string;
  includes?: string | null;
}

export interface ProgramInvitationsV1ByProgramAndEmailQuery {
  ProgramInvitationsV1: {
    byProgramAndEmail: ProgramInvitationsV1Connection | null;
  } | null;
}

export interface ProgramInvitationsV1ByProgramAndEmailQueryVariables {
  programId: string;
  email: string;
  includes?: string | null;
}

export interface ProgramInvitationsV1ByProgramAndExternalIdQuery {
  ProgramInvitationsV1: {
    byProgramAndExternalId: ProgramInvitationsV1Connection | null;
  } | null;
}

export interface ProgramInvitationsV1ByProgramAndExternalIdQueryVariables {
  programId: string;
  externalId: string;
  includes?: string | null;
}

export interface ProgramInvitationsV1ByRostersQuery {
  ProgramInvitationsV1: {
    byRosters: ProgramInvitationsV1Connection | null;
  } | null;
}

export interface ProgramInvitationsV1ByRostersQueryVariables {
  programId: string;
  rosterIds: string;
  includes?: string | null;
}

export interface ProgramInvitationsV1ByThirdPartyOrganizationAndUserQuery {
  ProgramInvitationsV1: {
    byThirdPartyOrganizationAndUser: ProgramInvitationsV1Connection | null;
  } | null;
}

export interface ProgramInvitationsV1ByThirdPartyOrganizationAndUserQueryVariables {
  thirdPartyOrganizationId: string;
  userId: string;
  includes?: string | null;
}

export interface ProgramInvitationsV1ByUserQuery {
  ProgramInvitationsV1: {
    byUser: ProgramInvitationsV1Connection | null;
  } | null;
}

export interface ProgramInvitationsV1ByUserQueryVariables {
  userId: string;
  includes?: string | null;
}

export interface ProgramInvitationsV1DeleteQuery {
  ProgramInvitationsV1: {
    delete: ProgramInvitationsV1Connection | null;
  } | null;
}

export interface ProgramInvitationsV1DeleteQueryVariables {
  id: string;
  includes?: string | null;
}

export interface ProgramInvitationsV1GetQuery {
  ProgramInvitationsV1: {
    get: ProgramInvitationsV1Connection | null;
  } | null;
}

export interface ProgramInvitationsV1GetQueryVariables {
  id: string;
  includes?: string | null;
}

export interface ProgramInvitationsV1MultiGetQuery {
  ProgramInvitationsV1: {
    multiGet: ProgramInvitationsV1Connection | null;
  } | null;
}

export interface ProgramInvitationsV1MultiGetQueryVariables {
  ids: string;
  includes?: string | null;
}

export interface ProgramInvitationsV1SearchQuery {
  ProgramInvitationsV1: {
    search: ProgramInvitationsV1Connection | null;
  } | null;
}

export interface ProgramInvitationsV1SearchQueryVariables {
  programId: string;
  text: string;
  rosterIds?: string | null;
  includes?: string | null;
}

// ========================================================================
// Definitions for naptime-link mutations
// ========================================================================

export interface ProgramInvitationsV1AcceptMutation {
  ProgramInvitationsV1: {
    accept: ProgramInvitationsV1Connection | null;
  } | null;
}

export interface ProgramInvitationsV1AcceptMutationVariables {
  id: string;
  includes?: string | null;
}

export interface ProgramInvitationsV1AcceptAsMutation {
  ProgramInvitationsV1: {
    acceptAs: ProgramInvitationsV1Connection | null;
  } | null;
}

export interface ProgramInvitationsV1AcceptAsMutationVariables {
  id: string;
  userId: string;
  includes?: string | null;
}

export interface ProgramInvitationsV1CappedMultiCreateMutation {
  ProgramInvitationsV1: {
    cappedMultiCreate: ProgramInvitationsV1Connection | null;
  } | null;
}

export interface ProgramInvitationsV1CappedMultiCreateMutationVariables {
  includes?: string | null;
}

export interface ProgramInvitationsV1CreateMutation {
  ProgramInvitationsV1: {
    create: ProgramInvitationsV1Connection | null;
  } | null;
}

export interface ProgramInvitationsV1CreateMutationVariables {
  includes?: string | null;
}

export interface ProgramInvitationsV1DeleteByInvitationIdsMutation {
  ProgramInvitationsV1: {
    deleteByInvitationIds: ProgramInvitationsV1Connection | null;
  } | null;
}

export interface ProgramInvitationsV1DeleteByInvitationIdsMutationVariables {
  includes?: string | null;
}

export interface ProgramInvitationsV1GenerateBulkUploadLocationMutation {
  ProgramInvitationsV1: {
    generateBulkUploadLocation: ProgramInvitationsV1Connection | null;
  } | null;
}

export interface ProgramInvitationsV1GenerateBulkUploadLocationMutationVariables {
  programId: string;
  includes?: string | null;
}

export interface ProgramInvitationsV1GetInvitationIdsByOrgMutation {
  ProgramInvitationsV1: {
    getInvitationIdsByOrg: ProgramInvitationsV1Connection | null;
  } | null;
}

export interface ProgramInvitationsV1GetInvitationIdsByOrgMutationVariables {
  orgId: string;
  includes?: string | null;
}

export interface ProgramInvitationsV1GetInvitationIdsByProgramsMutation {
  ProgramInvitationsV1: {
    getInvitationIdsByPrograms: ProgramInvitationsV1Connection | null;
  } | null;
}

export interface ProgramInvitationsV1GetInvitationIdsByProgramsMutationVariables {
  programIds: string;
  includes?: string | null;
}

export interface ProgramInvitationsV1GetTestingJwtMutation {
  ProgramInvitationsV1: {
    getTestingJwt: ProgramInvitationsV1Connection | null;
  } | null;
}

export interface ProgramInvitationsV1GetTestingJwtMutationVariables {
  programId: string;
  id: string;
  includes?: string | null;
}

export interface ProgramInvitationsV1JoinMutation {
  ProgramInvitationsV1: {
    join: ProgramInvitationsV1Connection | null;
  } | null;
}

export interface ProgramInvitationsV1JoinMutationVariables {
  programId: string;
  includes?: string | null;
}

export interface ProgramInvitationsV1MultiDeleteMutation {
  ProgramInvitationsV1: {
    multiDelete: ProgramInvitationsV1Connection | null;
  } | null;
}

export interface ProgramInvitationsV1MultiDeleteMutationVariables {
  programId: string;
  includes?: string | null;
}

export interface ProgramInvitationsV1MultiSendMutation {
  ProgramInvitationsV1: {
    multiSend: ProgramInvitationsV1Connection | null;
  } | null;
}

export interface ProgramInvitationsV1MultiSendMutationVariables {
  programId: string;
  includes?: string | null;
}

export interface ProgramInvitationsV1PatchMutation {
  ProgramInvitationsV1: {
    patch: ProgramInvitationsV1Connection | null;
  } | null;
}

export interface ProgramInvitationsV1PatchMutationVariables {
  id: string;
  includes?: string | null;
}

export interface ProgramInvitationsV1PreviewImportV2Mutation {
  ProgramInvitationsV1: {
    previewImportV2: ProgramInvitationsV1Connection | null;
  } | null;
}

export interface ProgramInvitationsV1PreviewImportV2MutationVariables {
  programId: string;
  rosterId?: string | null;
  s3Bucket: string;
  s3Key: string;
  includes?: string | null;
}

export interface ProgramInvitationsV1ProcessImportAsynchronouslyMutation {
  ProgramInvitationsV1: {
    processImportAsynchronously: ProgramInvitationsV1Connection | null;
  } | null;
}

export interface ProgramInvitationsV1ProcessImportAsynchronouslyMutationVariables {
  programId: string;
  rosterId?: string | null;
  s3Bucket: string;
  s3Key: string;
  sendInvitations: string;
  includes?: string | null;
}

export interface ProgramInvitationsV1ProcessImportSynchronouslyMutation {
  ProgramInvitationsV1: {
    processImportSynchronously: ProgramInvitationsV1Connection | null;
  } | null;
}

export interface ProgramInvitationsV1ProcessImportSynchronouslyMutationVariables {
  programId: string;
  rosterId?: string | null;
  s3Bucket: string;
  s3Key: string;
  sendInvitations: string;
  includes?: string | null;
}

export interface ProgramInvitationsV1SendMutation {
  ProgramInvitationsV1: {
    send: ProgramInvitationsV1Connection | null;
  } | null;
}

export interface ProgramInvitationsV1SendMutationVariables {
  programId: string;
  id: string;
  includes?: string | null;
}

export interface ProgramInvitationsV1SendAllPendingMutation {
  ProgramInvitationsV1: {
    sendAllPending: ProgramInvitationsV1Connection | null;
  } | null;
}

export interface ProgramInvitationsV1SendAllPendingMutationVariables {
  programId: string;
  includes?: string | null;
}

// ========================================================================
// Definitions for naptime-js
// ========================================================================

// Recursively applies Partial<T> to supported culling by the `fields` param.
type PartialConstruction<T> = {
  [TKey in keyof T]?: T[TKey] extends Array<infer TElement>
    ? Array<PartialConstruction<TElement>>
    : T[TKey] extends object
    ? PartialConstruction<T[TKey]>
    : T[TKey];
};

export class ProgramInvitationsV1NaptimeResource extends NaptimeResource {
  static RESOURCE_NAME = 'programInvitations.v1' as const;

  id!: string;

  programId!: string;

  invitee!: ProgramInvitee;

  expiresAt!: number;

  declines!: boolean;

  sendAttemptTimes!: Array<number>;

  reminderSendTimes!: Array<number>;

  rosterId!: string;

  thirdPartyOrganizationId!: string;

  createdAt?: number | null;

  // Intentionally "useless" to supply params type
  // eslint-disable-next-line @typescript-eslint/no-useless-constructor
  constructor(params: PartialConstruction<ProgramInvitationsV1>) {
    super(params);
  }
}
